import { PaletteOptions } from '@mui/material/styles';

import {
  Background,
  Error,
  Info,
  Primary,
  Secondary,
  Success,
  Surface,
  Status,
  Warning,
  Yellow,
  Flamingo,
  Turquoise,
  Gray,
  Indigo,
  Green,
  Orange,
  Red,
  White,
  Brand4,
} from '.';

export const palette: PaletteOptions = {
  primary: {
    main: Primary.default.main,
    hover: Primary.default.hover,
    pressed: Primary.default.pressed,
  },
  secondary: {
    main: Secondary.default.main,
    hover: Secondary.default.hover,
    pressed: Secondary.default.pressed,
  },
  info: {
    main: Info.default.main,
    hover: Indigo[80],
    pressed: Indigo[60],
  },
  success: {
    main: Success.default.main,
    hover: Green[60],
    pressed: Green[40],
  },
  warning: {
    main: Warning.default.main,
    hover: Orange[40],
    pressed: Orange[20],
  },
  error: {
    main: Error.default.main,
    hover: Red[70],
    pressed: Red[50],
  },
  background: {
    default: Background.main,
    paper: Surface.main,
  },
  status: Status,
  yellow: {
    main: Yellow[60],
    light: Yellow[40],
    dark: Yellow[80],
    hover: Yellow[50],
    pressed: Yellow[20],
    contrastText: Brand4.text,
  },
  flamingo: {
    main: Flamingo[60],
    light: Flamingo[40],
    dark: Flamingo[80],
    hover: Flamingo[50],
    pressed: Flamingo[30],
    contrastText: White,
  },
  turquoise: {
    main: Turquoise[70],
    light: Turquoise[50],
    dark: Turquoise[90],
    hover: Turquoise[60],
    pressed: Turquoise[40],
    contrastText: White,
  },
  turquoiseDark: {
    main: Turquoise[90],
    light: Turquoise[70],
    dark: Turquoise[110],
    hover: Turquoise[80],
    pressed: Turquoise[60],
    contrastText: White,
  },
  neutral: {
    main: Gray[10],
    light: Gray[10],
    dark: Gray[30],
    hover: Gray[20],
    pressed: Gray[40],
    contrastText: Gray[110],
  },
};
